/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Internship10Inputs */

const en_job_form_enum_internship10 = /** @type {(inputs: Job_Form_Enum_Internship10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internship`)
};

const de_job_form_enum_internship10 = /** @type {(inputs: Job_Form_Enum_Internship10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Praktikum`)
};

/**
* | output |
* | --- |
* | "Internship" |
*
* @param {Job_Form_Enum_Internship10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_internship10 = /** @type {((inputs?: Job_Form_Enum_Internship10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Internship10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_internship10(inputs)
	return en_job_form_enum_internship10(inputs)
});
export { job_form_enum_internship10 as "job_form_enum_INTERNSHIP" }